import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/MyCreditPoints/MyCreditPoints.js
const MyCreditPoints = createSectionForm({
  icon: "coupon-3-line",
  title: "My Credit Points",
  fields: [{ name: "title", label: "Heading", placeholder: "My Credit Points" }],
});

export default MyCreditPoints;
